import { ReactElement, useState } from 'react';

import SegmentPopper from 'components/Segments/SegmentPopper/SegmentPopper';
import SegmentsButton from 'components/Segments/SegmentsButton/SegmentsButton';
import Breadcrumbs from '@lotlinx-aws/sparky-component-library/Sparky/Breadcrumbs';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Popover from '@lotlinx-aws/sparky-component-library/Sparky/Popover';

import styles from './SegmentBreadcrumb.module.scss';
import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import { IconArrowUpRight, IconChartHistogram } from '@tabler/icons-react';
import { COLOR } from '@lotlinx-aws/sparky-component-library/Sparky/styles/vars';

interface SegmentBreadcrumbProps {
  pageTitle: string;
  pageTitle2?: string;
  buttonList?: { icon: ReactElement; onClick: () => void; aria: string; text?: string }[];
}

export default function SegmentBreadcrumb({
  pageTitle,
  pageTitle2,
  buttonList,
}: SegmentBreadcrumbProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Breadcrumbs
      className={styles.segmentBreadcrumbWrapper}
      pageTitles={
        pageTitle2
          ? [
              { icon: <IconChartHistogram size={20} color={COLOR.SPARKY_GREY_400} /> },
              { title: pageTitle2 },
              { title: pageTitle },
            ]
          : [
              { icon: <IconChartHistogram size={20} color={COLOR.SPARKY_GREY_400} /> },
              { title: pageTitle },
            ]
      }
    >
      <Flex column={false} alignItems='center' gap='8px'>
        {buttonList &&
          buttonList.map((button) => {
            if (button.text) {
              return (
                <Button
                  key={button.aria}
                  onClick={() => button.onClick()}
                  aria-label={button.aria}
                  size='md'
                  rightIcon={<IconArrowUpRight size={16} />}
                >
                  {button.text}
                </Button>
              );
            } else {
              return (
                <IconButton
                  key={button.aria}
                  onClick={() => button.onClick()}
                  aria-label={button.aria}
                  size='md'
                >
                  {button.icon}
                </IconButton>
              );
            }
          })}
        <Popover
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          showCloseButton={false}
          isHoverTriggered={false}
          popupContent={<SegmentPopper />}
          verticalOffset={8}
          avoidCollisions
          showCarrat={false}
          side='bottom'
          align='end'
        >
          <div>
            <SegmentsButton />
          </div>
        </Popover>
      </Flex>
    </Breadcrumbs>
  );
}
